export const navigation = [
  {
    name: 'Submissions',
    url: '/dashboard',
    icon: 'icon-calendar'
  }
];



// WEBPACK FOOTER //
// /home/ashutosh/submission/src/app/_nav.ts